import React from 'react';
import { Toast as ToastType } from '../types';

interface ToastProps {
  toasts: ToastType[];
  onRemove: (id: string) => void;
}

export const Toast: React.FC<ToastProps> = ({ toasts, onRemove }) => {
  return (
    <div className="fixed bottom-4 right-4 z-50 space-y-2">
      {toasts.map(toast => (
        <div
          key={toast.id}
          className={`px-6 py-3 rounded-lg shadow-lg text-white toast-enter ${
            toast.type === 'success' ? 'bg-green-500' : 'bg-red-500'
          }`}
          onClick={() => onRemove(toast.id)}
          style={{ cursor: 'pointer' }}
        >
          <div className="flex items-center space-x-2">
            <i className={`fas fa-${toast.type === 'success' ? 'check-circle' : 'exclamation-circle'}`}></i>
            <span>{toast.message}</span>
          </div>
        </div>
      ))}
    </div>
  );
}; 